import { render } from "./PhotoPage.vue?vue&type=template&id=7e18837e&scoped=true"
import script from "./PhotoPage.vue?vue&type=script&lang=js"
export * from "./PhotoPage.vue?vue&type=script&lang=js"

import "./PhotoPage.vue?vue&type=style&index=0&id=7e18837e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e18837e"]])

export default __exports__